import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ProtectedRoute } from './ProtectedRoute';
import { PublicRoute } from './PublicRoute';
import { Login } from '../pages/login/Login';

export function AppRoutes() {
	const { user } = useAuth();
	return (
		<Routes>
			{/* Root: redirect based on auth state */}
			<Route
				path="/"
				element={<Navigate to={user ? '/dashboard' : '/login'} replace />}
			/>

			{/* Public routes */}
			<Route
				path="/login"
				element={
					<PublicRoute>
						<Login />
					</PublicRoute>
				}
			/>

			{/* Protected routes (all main app pages) */}
			<Route path="/*" element={<ProtectedRoute />} />
		</Routes>
	);
}


